import { StyleSheet } from "@react-pdf/renderer";

export const quoteStyles = StyleSheet.create({
  page: {
    padding: "10px 20px",
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: "#ffffff",
  },
  // header
  header: {
    textAlign: 'center',
    fontSize: 12,
    fontWeight: 'bold',
  },
  myTableHeaderCell: {
    fontSize: 16,
  },
  tableLogoImageCol: {
    width: "100%",
    borderWidth: 0,
    textAlign: "left"
  },
  logoImage: {
    width: "auto",
    height: "55px",
  },
  tableHeadingTextCol: {
    marginTop: "-25px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  // table body
  image: {
    height: "90px",
    objectFit: "contain"
  },
  table: {
    marginTop: 5,
    marginBottom: 5,
    border: "1px solid #63707E",
  },
  tableRow: {
    flexDirection: "row",
  },
  tableHeadCol:
  {
    borderWidth: 0,
    padding: "3px 0 2px 2px",
    textAlign: "center",
    width: "100px"
  },
  tableLeftCol: {
    width: "100%",
    borderWidth: 0,
    textAlign: "center",
  },
  tableCol: {
    width: "100%",
    borderWidth: 0,
    padding: "3px 0 3px 2px",
    textAlign: "center",
  },
  tableRightCol: {
    width: "100%",
    borderWidth: 0,
    textAlign: "center",
  },
  tableHeadCell: {
    textAlign: "left",
    fontSize: 9,
    color: '#63707E',
  },
  tableColonCell: {
    textAlign: "left",
    fontSize: 9,
    color: '#000811',
    padding: "3px 0 2px 2px",
  },
  tableCell: {
    textAlign: "left",
    fontSize: 9,
    color: '#000811',
    paddingLeft: "5px",
  },
  // project row
  projectTableRow: {
    flexDirection: "row",
    borderTop: "1px solid #63707E",
  },
  tableProjectCol: {
    width: "100%",
    borderWidth: 0,
    padding: "2px 0 2px 2px",
    textAlign: "center",
  },
  tableProjectRow: {
    flexDirection: "row",
  },
  projectTableHeadCol:
  {
    width: "85px",
    borderWidth: 0,
    padding: "2px 0 3px 2px",
    textAlign: "center",
  },
  tableHeadProjectCell: {
    textAlign: "left",
    fontSize: 9,
    color: '#63707E',
  },
  tableColonProjectCell: {
    textAlign: "left",
    fontSize: 9,
    color: '#000811',
    padding: "2px 0 2px 0",
  },
  tableProjectCell: {
    textAlign: "left",
    fontSize: 9,
    color: '#000811',
    paddingLeft: "5px",
  },
  proposalText: {
    fontSize: 9,
    marginTop: 5,
    marginBottom: 10,
  },
  // model table
  modelProductTable: {
    display: "table",
    width: "100%",
    border: "1px solid #63707E",
  },
  modelProductTableRow: {
    flexDirection: "row",
    fontSize: "10px",
    borderBottom: "1px solid #63707E",
  },
  modelProductTableColumn: {
    width: "100%",
    borderBottomWidth: 0,
    flexDirection: "row",
  },
  productTableColumn: {
    width: "100%",
    borderBottomWidth: 0,
    flexDirection: "row",
    justifyContent: "flex-end"
  },
  modelProductTableKeyCell: {
    padding: "3px",
    borderBottomWidth: 0,
    color: '#63707E',
  },
  productTableKeyCell: {
    padding: "3px",
    borderBottomWidth: 0,
    color: '#63707E',
  },
  modelProductTableValueCell: {
    padding: "3px",
    borderBottomWidth: 0,
    color: '#000811',
  },
  productTableValueCell: {
    padding: "3px",
    borderBottomWidth: 0,
    color: '#000811',
  },
  modelProductListTableRow: {
    flexDirection: "row",
    fontSize: "9px",
    borderBottomWidth: 0
  },
  modelProductListTableColumn: {
    width: "100%",
    borderTopWidth: 0,
    flexDirection: "row",
  },
  modelProductListKeyTableCell: {
    padding: "3px",
    borderTopWidth: 0,
    color: '#63707E',
  },
  modelProductListValueTableCell: {
    padding: "3px",
    borderTopWidth: 0,
    color: '#000811',
  },
  modelProductListDetailsTable: {
    display: "table",
    fontSize: "9px",
    textAlign: "center",
    borderTop: "1px solid #63707E",
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    height: "auto",
  },
  modelProductListDetailRow: {
    flexDirection: "row",
  },
  modelProductListDimensionDetailRow: {
    flexDirection: "row",
    height: "auto",
  },
  modelProductListDetailSlHeadColumn: {
    width: "30px",
    borderRight: "1px solid #63707E",
    borderBottom: "1px solid #63707E",
    borderLeft: "1px solid #63707E",
    backgroundColor: "#edf2f6",
    color: "#000811",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  modelProductListDetailTableHeadCell: {
    paddingTop: "3px",
    paddingBottom: "3px",
    fontWeight: 700,
    fontSize: "8px",
  },
  modelProductListDetailTagRefHeadColumn: {
    width: "130px",
    borderRight: "1px solid #63707E",
    borderBottom: "1px solid #63707E",
    backgroundColor: "#edf2f6",
    color: "#000811",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  modelProductListDetailModelHeadColumn: {
    width: "100px",
    borderRight: "1px solid #63707E",
    borderBottom: "1px solid #63707E",
    backgroundColor: "#edf2f6",
    color: "#000811"
  },
  modelProductListDetailSizeHeadColumn: {
    width: "170px",
    borderRight: "1px solid #63707E",
    borderBottom: "1px solid #63707E",
    backgroundColor: "#edf2f6",
    color: "#000811",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  modelProductListDetailQtyHeadColumn: {
    width: "80px",
    borderRight: "1px solid #63707E",
    borderBottom: "1px solid #63707E",
    backgroundColor: "#edf2f6",
    color: "#000811",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  modelProductListDetailUnitHeadColumn: {
    width: "130px",
    borderRight: "1px solid #63707E",
    borderBottom: "1px solid #63707E",
    backgroundColor: "#edf2f6",
    color: "#000811",
    paddingLeft: "10px",
    paddingRight: "10px",
    textAlign: "right"
  },
  modelProductListDetailTotalHeadColumn: {
    width: "130px",
    borderRight: "1px solid #63707E",
    borderBottom: "1px solid #63707E",
    backgroundColor: "#edf2f6",
    color: "#000811",
    paddingLeft: "10px",
    paddingRight: "10px",
    textAlign: "right"
  },
  modelProductListDetailNotesHeadColumn: {
    width: "180px",
    borderBottom: "1px solid #63707E",
    borderRight: "1px solid #63707E",
    backgroundColor: "#edf2f6",
    color: "#000811",
    paddingLeft: "10px",
    paddingRight: "10px",
  },

  modelProductListDetailSlColumn: {
    width: "30px",
    borderRight: "1px solid #63707E",
    borderBottom: "1px solid #63707E",
    borderLeft: "1px solid #63707E",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  modelProductListDetailTableCell: {
    paddingTop: "2px",
    fontSize: "8px",
  },
  modelProductListDetailTableFaceSizeCell: {
    paddingTop: "2px",
    paddingBottom: "2px",
    fontSize: "8px",
    height: "auto",
  },
  modelProductListDetailTableNoteCell: {
    paddingTop: "2px",
    paddingBottom: "2px",
    fontSize: "8px",
    flexGrow: 1,
  },
  modelProductListDetailTagRefColumn: {
    width: "130px",
    borderRight: "1px solid #63707E",
    borderBottom: "1px solid #63707E",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  modelProductListDetailModelNameColumn: {
    width: "100px",
    borderRight: "1px solid #63707E",
    borderBottom: "1px solid #63707E",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  modelProductListDetailSizeColumn: {
    width: "170px",
    borderRight: "1px solid #63707E",
    borderBottom: "1px solid #63707E",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  modelProductListDetailQtyColumn: {
    width: "80px",
    borderRight: "1px solid #63707E",
    borderBottom: "1px solid #63707E",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  modelProductListDetailUnitColumn: {
    width: "130px",
    borderRight: "1px solid #63707E",
    borderBottom: "1px solid #63707E",
    paddingLeft: "10px",
    paddingRight: "10px",
    textAlign: "right"
  },
  modelProductListDetailTotalColumn: {
    width: "130px",
    borderRight: "1px solid #63707E",
    borderBottom: "1px solid #63707E",
    paddingLeft: "10px",
    paddingRight: "10px",
    textAlign: "right"
  },
  modelProductListDetailNotesColumn: {
    width: "180px",
    height: "auto",
    borderBottom: "1px solid #63707E",
    borderRight: "1px solid #63707E",
    paddingLeft: "5px",
    paddingRight: "5px",
  },
  modelProductListDetailSlSubTotalColumn: {
    width: "30px",
    borderLeft: 0,
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  modelProductListDetailTagRefSubTotalColumn: {
    width: "152px",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  modelProductListDetailSizeSubTotalColumn: {
    width: "202px",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  modelProductListDetailQtySubTotalColumn: {
    width: "100px",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  modelProductListDetailUnitSubTotalColumn: {
    width: "150px",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  modelProductListDetailTotalSubTotalColumn: {
    width: "150px",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  modelProductListDetailNotesSubTotalColumn: {
    width: "150px",
    borderRight: 0,
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  // details table
  detailsTable: {
    display: "table",
    width: "auto",
    textAlign: "right",
    border: "1px solid #63707E",
  },
  detailsTableRow: {
    flexDirection: "row",
  },
  detailsTableColumn: {
    width: "100%",
    borderTop: "0px",
  },
  detailsTableCell: {
    fontSize: 9,
    border: 0,
    paddingRight: "10px",
    paddingBottom: "5px",
  },
  detailsQarTableColumn: {
    width: "10%",
    border: 0,
  },
  detailsQarTableCell: {
    fontSize: 9,
    border: 0,
    paddingRight: "10px",
    color: '#63707E'
  },
  detailsPriceTableColumn: {
    width: "15%",
    border: 0,
    textAlign: 'right'
  },
  detailsPriceTableCell: {
    fontSize: 9,
    textAlign: 'right',
    paddingRight: "10px",
    border: 0
  },
  totalDetailsTableRow: {
    flexDirection: "row",
    alignItems: "center"
  },
  totalDetailsTableColumn: {
    width: "30%",
    borderTop: "0px",
    textAlign: "left"
  },
  totalDetailsQarTableColumn: {
    width: "10%",
    border: 0,
  },
  totalDetailsPriceTableColumn: {
    width: "75%",
    border: 0,
  },
  totalDetailsFullPriceTableColumn: {
    width: "100%",
    border: 0,
  },
  totalDetailsPriceTableCell: {
    fontSize: 9,
    textAlign: 'left',
    paddingRight: "10px",
    border: 0
  },
  grandTotalDetailsTableColumn: {
    width: "26%",
    borderTop: "0px",
  },
  totalDetailsTableCell: {
    fontSize: 9,
    border: 0,
    paddingRight: "10px", 
  },
  grandTotalDetailsQarTableColumn: {
    width: "13%",
    border: 0,
  },
  grandTotalDetailsPriceTableColumn: {
    width: "20%",
    border: 0, 
  },
  // net total
  detailsNetTotalTableColumn: {
    width: "81%",
    borderRight: "1px solid #63707E",
    borderTop: "1px solid #63707E",
    borderBottom: 0,
    borderLeft: 0,
  },
  detailsQarNetTotalTableColumn: {
    width: "37%",
    borderTop: "1px solid #63707E",
    borderBottom: 0,
  },
  detailsPriceNetTotalTableColumn: {
    width: "40%",
    textAlign: 'right',
    borderTop: "1px solid #63707E",
    borderLeft: "1px solid #63707E",
    borderRight: 0,
    borderBottom: 0,
  },
  // terms & condition
  termsandConditionTable: {
    display: "table",
    paddingRight: "15px",
    width: "auto",
    marginTop: 10,
  },
  termsandConditionTableRow: {
    flexDirection: "row",
    marginRight: 50,
  },
  termsandConditionTableLabelCell: {
    fontSize: 9,
    textAlign: "left",
    lineHeight: 1.5,
    color: '#63707E'
  },
  termsandConditionTableHeadingCell: {
    fontSize: 10,
    textAlign: "left",
    lineHeight: 1.5,
    fontWeight: 700,
    color: '#000811',
    width: "100px",
    textDecoration: "underline",
  },
  termsandConditionTableHeadCell: {
    fontSize: 9,
    textAlign: "left",
    lineHeight: 1.5,
    fontWeight: 700,
    color: '#000811',
    width: "100px"
  },
  termsandConditionTableCell: {
    fontSize: 9,
    textAlign: "left",
    lineHeight: 1.5,
    fontWeight: 700,
    color: '#000811',
    paddingLeft: "10px",
    width: "90%",
  },
  termsandConditionColonTableCell: {
    fontSize: 9,
    textAlign: "left",
    lineHeight: 1.5,
    fontWeight: 700,
    color: '#000811'
  },
  // footer
  footer: {
    textAlign: 'center',
    fontSize: 12,
    marginTop: "10px",
  },
  declarationTable: {
    display: "table",
    paddingRight: "15px",
    width: "auto",
    marginTop: 10,
  },
  declarationTableRow: {
    flexDirection: "row",
    marginRight: 50,
  },
  italicFooterText: {
    fontSize: 9,
  },
  boldFooterText: {
    paddingTop: 10,
    fontSize: 9,
    fontWeight: "bold",
  },
  footerTableRow: {
    flexDirection: "row",
  },
  footerTableCell: {
    fontSize: 8,
    paddingTop: "20px"
  },
  termsFooterTableCell: {
    fontSize: 8,
  },
  termsfooter: {
    position: 'absolute',
    bottom: 7,
    left: 0,
    right: 0,
    textAlign: 'center',
    fontSize: 12,
    paddingLeft: "20px",
    paddingRight: "20px",
  },
});